function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
var priv = Symbol('private');
var InputSwitch = function () {
    function InputSwitch(options) {
        var _this = this;
        _classCallCheck(this, InputSwitch);
        this.options = options;
        var title = this.options.title || '标题示例', tips = this.options.tips || '', onlyswitch = !(this.options.input && true);
        var _ref = this.options.input || {
                placeholder: '提示示例',
                value: '初值示例'
            }, placeholder = _ref.placeholder, value = _ref.value;
        this.callback = this.options.callback || function () {
            return true;
        };
        this.init = this.options.init || function () {
            return true;
        };
        this[priv] = {};
        this[priv].template = '<div class="dplayer-setting-item dplayer-setting-input-switch" title="'.concat(tips, '"><span class="dplayer-label input-switch-title">').concat(title, '</span><input type="number" placeholder="').concat(placeholder, '" value="').concat(value, '"><div class="dplayer-toggle"><input class="dplayer-toggle-setting-input" type="checkbox" name="dplayer-toggle"><label for="dplayer-toggle"></label></div></div>');
        var tmp = document.createElement('div');
        tmp.innerHTML = this[priv].template;
        this[priv].container = tmp.firstElementChild;
        this[priv]['switch'] = this[priv].container.querySelector('.dplayer-toggle-setting-input');
        this[priv].input = this[priv].container.querySelector('input');
        this[priv]['switch'].checked = this.options['switch'] && typeof this.options['switch'] === 'boolean' || false;
        if (onlyswitch) {
            this[priv].input.style.setProperty('display', 'none');
        }
        this[priv].container.querySelector('.dplayer-toggle').addEventListener('click', function (e) {
            var event = e || window.event;
            event.preventDefault();
            if (_this.callback) {
                var args = [
                    event,
                    !_this[priv]['switch'].checked
                ];
                if (!onlyswitch) {
                    args.push(_this[priv].input.value);
                }
                var ret = _this.callback.apply(_this, args);
                if (ret || ret === undefined) {
                    _this[priv]['switch'].checked = !_this[priv]['switch'].checked;
                }
            } else {
                _this[priv]['switch'].checked = !_this[priv]['switch'].checked;
            }
        });
        this[priv].input.addEventListener('change', function (e) {
            var event = e || window.event;
            event.preventDefault();
            if (onlyswitch) {
                _this.callback && _this.callback.apply(_this, [
                    event,
                    _this[priv]['switch'].checked
                ]);
            } else {
                _this.callback && _this.callback.apply(_this, [
                    event,
                    _this[priv]['switch'].checked,
                    _this[priv].input.value
                ]);
            }
        });
        this.options.target.append(this[priv].container);
        this.init && this.init();
    }
    _createClass(InputSwitch, [
        {
            key: 'notice',
            value: function notice(msg) {
                this.options.player.notice(msg);
            }
        },
        {
            key: 'toggle',
            value: function toggle(b) {
                var isshow;
                if (arguments.length === 0) {
                    isshow = this[priv].container.style.getPropertyValue('display') === 'none';
                } else {
                    isshow = !!b;
                }
                if (isshow) {
                    this[priv].container.style.removeProperty('display');
                } else {
                    this[priv].container.style.setProperty('display', 'none');
                }
                return this;
            }
        },
        {
            key: 'toggleSwitch',
            value: function toggleSwitch(b) {
                if (arguments.length === 0) {
                    this[priv]['switch'].checked = !this[priv]['switch'].checked;
                } else {
                    this[priv]['switch'].checked = !!b;
                }
                return this;
            }
        },
        {
            key: 'enable',
            value: function enable() {
                this[priv].input.disabled = false;
            }
        },
        {
            key: 'disable',
            value: function disable() {
                this[priv].input.disabled = true;
            }
        }
    ]);
    return InputSwitch;
}();
export default function (options) {
    return new Proxy(new InputSwitch(options), {
        set: function set(target, property, value, _receiver) {
            if (property === 'title') {
                target[priv].container.querySelector('span.dplayer-label.input-switch-title').innerText = value;
            } else if (property === 'value') {
                target[priv].input.value = value;
            } else if (property === 'switch') {
                return false;
            }
            target[property] = value;
            return true;
        },
        get: function get(target, property, _receiver) {
            if (property === 'title') {
                return target[priv].container.querySelector('span.dplayer-label.input-switch-title').innerText;
            } else if (property === 'value') {
                return target[priv].input.value;
            } else if (property === 'switch') {
                return target[priv]['switch'].checked;
            }
            return target[property];
        },
        deleteProperty: function deleteProperty(target, property) {
            delete target[property];
            return true;
        }
    });
};